import React from 'react';
import {LabelingView} from '../labeling-page';
import { useSelector } from 'react-redux';

export const Wrapper = () => {
  const defaultstyle = useSelector(state=> state.labelsData.defaultstyle);
  return (
    <div className="wrapper" style={defaultstyle}>
      <LabelingView />
    </div>
  );
}
